import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import withDrawer from '../../components/withDrawer'
import MenuIcon from '@material-ui/icons/Menu'
import { Button, Typography, Card, TextField } from '@material-ui/core'
import Horizontal_Logo from '../../assets/images/sselogo1(nobackwhite).png'
import MoreVert from '@material-ui/icons/MoreVert'
import { withStyles } from '@material-ui/core'
import { updateExsistingEvent } from '../../actions/events'
import moment from 'moment'
import ShowingCard from '../../components/ShowingCard'
import styles from './styles'
import { doRefresh } from '../../actions/authentication'

//TODO NOTES update

class ShowingComplete extends React.Component {
  state = {
    data: {
      phone: '',
      firstName: '',
      lastName: '',
      title: '',
      address: '',
      id: ''
    },
    address: '',
    addressParts: {},
    lat: '',
    lng: '',
    zoom: 13,
    size: '400x200',
    foundClientUser: false,
    endTimeFormatted: '',
    logEvent: {},
    // logAddress: '',
    notes: '',
    showingDuration: null,
    endTime: '',
    gotTime: false,
    gotTime2: false,
    elapsedTIME: '',
    alreadyUpdated: false
  }

  componentDidUpdate() {
    if (!this.state.endTimeFormatted && !this.state.refreshed) {
      this.props.dispatch(doRefresh()).then(x => {
        this.setState({ refreshed: true })
        const { events } = this.props.authentication.authenticatedUser
        const { gotTime, gotTime2 } = this.state
        const eIndex = events.findIndex(
          x => `${x.id}` === `${this.props.match.params.id}`
        )

        if (!gotTime && eIndex > -1) {
          const endTimeDate = events[eIndex].end_time
          this.setState({ gotTime: true, endTime: endTimeDate })
        } else if (!gotTime2 && this.state.endTime) {
          // let logAddress = ''
          let logEvent = events[eIndex]
          let newState
          if (events[eIndex].attendees.length > 0) {
            newState = events[eIndex].attendees[0]
          }

          let newEndTime = moment.utc(this.state.endTime).local().format('YYYY-MM-DD h:mm:ss a')
          console.log(newEndTime, '>>>>>>newEndTime')

          let endTime = newEndTime
          let startTime = moment.utc(
            events[eIndex].start_time).local().format(
            'YYYY-MM-DD h:mm:ss a'
          )
          // const timeDur = endTime.subtract(
          //   startTime
          // )
            console.log(endTime , 'fgsuyfgd', startTime)
          const elapsedTIME = moment
            .duration(moment(endTime).diff(moment(startTime)))
            .as('seconds')
            .toFixed(2)
            const endTimeFormatted = endTime
          // const endTimeFormatted = timeDur.format('MMMM Do YYYY, h:mm:ss a')
          const notes = logEvent.notes || ''
          const data = this.state.data
          if (events[eIndex].attendees.length > 0) {
            data.phone = newState.phone.substring(2)
            data.firstName = newState.first_name
            data.lastName = newState.last_name
          }
          this.setState({
            data,
            endTimeFormatted,
            logEvent,
            // logAddress,
            notes,
            gotTime2: true,
            elapsedTIME
          })
        } else {
          //
        }
      })
    }
  }

  componentWillMount() {
    this.props.dispatch(doRefresh()).then(x => {
      let { events } = this.props.authentication.authenticatedUser

      const eIndex = events.findIndex(x => {
        return x.id === +this.props.match.params.id
      })

      if (eIndex !== -1) {
        if (events && events[eIndex].attendees.length > 0) {
          let logEvent = events[eIndex]

          this.setState({
            endTime: logEvent.endTime
          })
        }
      }
    })
  }

  handleOnChange = (e, obj) => {
    if (obj) {
      this.setState({
        address: e,
        addressParts: obj
      })
    } else {
      this.setState({
        address: e.target.value
      })
    }
  }

  handleUpdate = () => {
    const { id: eventId } = this.props.match.params
    const { addressParts, notes, data } = this.state
    const { id: attendeeId } = data

    this.props.dispatch(
      updateExsistingEvent(addressParts, attendeeId, eventId, notes)
    )
    this.props.history.push('/showings')
  }

  render() {
    const { history, toggleDrawer, authentication } = this.props
    const { endTimeFormatted, elapsedTIME } = this.state
    const { authenticatedUser } = authentication
    const { events } = authenticatedUser

    let minutes = Math.round(elapsedTIME / 60)
    let seconds = Math.round(
      (elapsedTIME / 60 - Math.round(elapsedTIME / 60)) * 60
    )
    let hours = 0
    minutes = minutes <= 0 ? '00' : minutes
    seconds = seconds <= 0 ? '00' : seconds
    if (minutes >= 60) {
      hours = Math.floor(minutes / 60)
      minutes -= hours * 60
    }

    if (/^\d$/.test(seconds)) {
      seconds = '0' + seconds
    }
    if (/^\d$/.test(minutes)) {
      minutes = '0' + minutes
    }
    if (/^\d$/.test(hours) && hours !== 0) {
      hours = '0' + hours
    }
    const eventIndex = events.findIndex(
      x => `${x.id}` === `${this.props.match.params.id}`
    )
    const event = events[eventIndex]
    const attendeeLength = event.attendees.length
    return (
      <div className="showings-detail-app">
        <div className="showings-detail-header">
          <MenuIcon
            className="showings-detail-menu"
            onClick={() => toggleDrawer()}
          />
          <img
            src={Horizontal_Logo}
            className="showings-detail-logo"
            alt="logo"
          />
          <MoreVert
            className="showings-detail-menu"
            alt="MoreVert"
            style={{ visibility: 'hidden' }}
          />
        </div>

        <div>
          <div className="showings-detail-license">
            {/* CARDS MAP AND CONTACT DETAILS */}

            <Typography variant="h5" color="primary">{`${
              attendeeLength === 1
                ? `${event.attendees[0].first_name !== null ? event.attendees[0].first_name : ''} ${
                    event.attendees[0].last_name !== null ? event.attendees[0].last_name : ''
                  }`
                : attendeeLength > 1
                ? 'Multiple clients'
                : 'No Client'
            }`}</Typography>
            <Typography>{`${endTimeFormatted}`}</Typography>

            <div
              style={{
                borderTop: '1px solid',
                paddingTop: '12px',
                borderColor: '#cecbcb'
              }}
            />
            <div style={{ height: '70vh' }}>
              <Typography
                variant="h1"
                color="secondary"
                style={{
                  fontWeight: '500',
                  fontFamily: 'Roboto'
                }}
              >
                {hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`}
              </Typography>

              <div className="showings-cards">
                {[
                  events[
                    events.findIndex(x => x.id === +this.props.match.params.id)
                  ]
                ].map(x => (
                  <ShowingCard
                    key={x.id}
                    data={x}
                    history={history}
                    name="view more"
                  />
                ))}

                {/* Notes */}
                <Card style={{ marginTop: '10px' }}>
                  <TextField
                    id="standard-multiline-static"
                    label="Notes"
                    multiline
                    rows="6"
                    value={this.state.notes}
                    onChange={e => {
                      this.setState({ notes: e.target.value })
                    }}
                    style={{
                      margin: '16px',
                      paddingRight: '16px',
                      width: '79vw',
                      marginTop: '8px',
                      paddingTop: '6px'
                    }}
                    className="standard-multiline-static"
                    margin="normal"
                  />
                </Card>
              </div>

              {/* BUTTONS */}
              <div className="showings-done-buttons-wrapper">
                <div className="showings-done-buttons">
                  <Button
                    variant="contained"
                    className="client-card-footerButton"
                    color="primary"
                    onClick={() => this.handleUpdate()}
                  >
                    SAVE
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    profile: state.profile,
    pics: state.pics
  }
}
const mapActionsToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch({ type: 'DRAWER_TOGGLED', payload: true }),
    dispatch
  }
}

export default withDrawer(
  compose(
    connect(
      mapStateToProps,
      mapActionsToProps
    ),
    withStyles(styles)
  )(ShowingComplete)
)
